export class BoschBookingForm {

  constructor(public parkingId: string,
              public startDate: string,
              public endDate: string,
              public firstName: string,
              public lastName: string,
              public driverLang: string,
              public taskId: number,
              public licensePlate: string,
              public additionalAccessType: string[]) {
  }

}
